export enum CustomOperatorValue {
  BooleanIsEmpty = 'boolean-is-empty',
  BooleanIsNotEmpty = 'boolean-is-not-empty',
  ContractType = 'contract-type',
  ContractTypeIsEmpty = 'contract-type-is-empty',
  ContractTypeIsNotEmpty = 'contract-type-is-not-empty',
  ContractTypeNotAnyOf = 'contract-type-not-any-of',
  DocumentStatus = 'document-status',
  FileType = 'file-type',
  FileTypeNotAnyOf = 'file-type-not-any-of',
  Label = 'label',
  LabelIsEmpty = 'label-is-empty',
  LabelIsNotEmpty = 'label-is-not-empty',
  LabelNotAnyOf = 'label-not-any-of',
  Owner = 'owner',
  OwnerNotAnyOf = 'owner-not-any-of',
  Party = 'party',
  PartyIsEmpty = 'party-is-empty',
  PartyIsNotEmpty = 'party-is-not-empty',
  PartyNotAnyOf = 'party-not-any-of',
  QuestionSelectNotAnyOf = 'question-select-not-any-of',
  RowStatusAnyOf = 'row-status-any-of',
  RowStatusNotAnyOf = 'row-status-not-any-of',
  WorkflowAssigneeAnyOf = 'workflow-assignee-any-of',
  WorkflowAssigneeIsEmpty = 'workflow-assignee-is-empty',
  WorkflowAssigneeIsNotEmpty = 'workflow-assignee-is-not-empty',
  WorkflowAssigneeNotAnyOf = 'workflow-assignee-not-any-of',
  WorkflowBoard = 'workflow-board',
  WorkflowBoardIsEmpty = 'workflow-board-is-empty',
  WorkflowBoardIsNotEmpty = 'workflow-board-is-not-empty',
  WorkflowBoardNotAnyOf = 'workflow-board-not-any-of',
  WorkflowColumn = 'workflow-column',
  WorkflowColumnCategoryIsEmpty = 'workflow-column-category-is-empty',
  WorkflowColumnCategoryIsNotEmpty = 'workflow-column-category-is-not-empty',
  WorkflowColumnIsEmpty = 'workflow-column-is-empty',
  WorkflowColumnIsNotEmpty = 'workflow-column-is-not-empty',
  WorkflowColumnNotAnyOf = 'workflow-column-not-any-of',
  WorkflowPriority = 'workflow-priority',
  WorkflowPriorityIsEmpty = 'workflow-priority-is-empty',
  WorkflowPriorityIsNotEmpty = 'workflow-priority-is-not-empty',
  WorkflowPriorityNotAnyOf = 'workflow-priority-not-any-of',
  WorkflowState = 'workflow-state',
  WorkflowStateIsEmpty = 'workflow-state-is-empty',
  WorkflowStatus = 'workflow-status',
  WorkflowType = 'workflow-type',
  WorkflowTypeNotAnyOf = 'workflow-type-not-any-of',
}
